import { z } from "zod";

// ── Saved View Entity ──

export const SavedViewEntitySchema = z.enum(["profiles", "companies", "schools"]);
export type SavedViewEntity = z.infer<typeof SavedViewEntitySchema>;

// ── Saved View Scope ──

export const SavedViewScopeSchema = z.enum(["user", "licence"]);
export type SavedViewScope = z.infer<typeof SavedViewScopeSchema>;

// ── Saved View Response ──

export const SavedViewResponseSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    entity: SavedViewEntitySchema,
    filters: z.unknown().optional(),
    scope: SavedViewScopeSchema,
    user_id: z.uuid(),
    licence_id: z.uuid(),
    created_at: z.string(),
    updated_at: z.string(),
});
export type SavedViewResponse = z.infer<typeof SavedViewResponseSchema>;

// ── Create Saved View ──

export const CreateSavedViewRequestSchema = z.object({
    name: z.string().min(1).max(100),
    entity: SavedViewEntitySchema,
    filters: z.unknown().optional(),
    scope: SavedViewScopeSchema.optional().default("user"),
});
export type CreateSavedViewRequest = z.infer<typeof CreateSavedViewRequestSchema>;

// ── Update Saved View ──

export const UpdateSavedViewRequestSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    filters: z.unknown().optional(),
    scope: SavedViewScopeSchema.optional(),
});
export type UpdateSavedViewRequest = z.infer<typeof UpdateSavedViewRequestSchema>;

// ── Wrappers ──

export const SavedViewListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(SavedViewResponseSchema),
});

export const SavedViewDetailResponseSchema = z.object({
    success: z.boolean(),
    data: SavedViewResponseSchema,
});
